<template>
  <modal width="40" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div>
      <h2 class="font-semibold text-xl mb-4">Manage Pick-up Schedule</h2>
      <p>Manage pick-up schedule for your booking.</p>
      <p class="flex justify-between items-center my-5">
        <span
          >Shipment ID:
          {{
            shipping ? shipping.shippingReference : "N/A"
          }}</span
        >
        <span class="text-primary-green cursor-pointer" @click="$emit('requestReturn')"
          >Preview Shipping Label</span
        >
      </p>

      <div class="w-full">
        <label class="block w-full">Date</label>
        <el-date-picker
          type="date"
          v-model="date"
          class="w-full"
          placeholder="12 - 12 - 2022"
          format="yyyy/MM/dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>

        <label>From</label>
        <el-time-picker
          v-model="pickUpTime_1"
          class="w-full"
          placeholder="Pick a time"
        />

        <label>To</label>
        <el-time-picker
          v-model="pickUpTime_2"
          class="w-full"
          placeholder="Pick a time"
        />
      </div>

      <div class="flex justify-between items-center pt-24">
        <span class="cursor-pointer" @click="$emit('close-modal')">cancel</span>
        <base-button :loading="isloading" text="Save" @click="updateShipping" />
      </div>
    </div>
  </modal>
</template>

<script>
import moment from "moment";

export default {
  props: {
    showModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      date: "",
      pickUpTime_1: "",
      pickUpTime_2: "",
      isloading: false,
    };
  },
  computed: {
    shipping() {
      return this.$store.getters.newCurrentShipping;
    },
    payload() {
      return {
        pickUpTime: [
          this.pickUpTime_1 ? moment(this.pickUpTime_1).format("HH:mm") : null,
          this.pickUpTime_2 ? moment(this.pickUpTime_2).format("HH:mm") : null,
        ],
        pickUpDays: this.date
          ? moment(this.date).format("YYYY-MM-DD")
          : undefined,
      };
    },
  },
  methods: {
    async updateShipping() {
      this.isloading = true;
      try {
        await this.$_updateShipping(this.shipping.id, this.payload);
        await this.$store.getters.getBookingTableData();
        this.$emit("requestReturn");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isloading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-date-editor.el-input {
  width: 100%;
}
</style>
